var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"commission"},[(_vm.me)?_c('Examiner',{attrs:{"sender":true,"examiner":_vm.me}}):_vm._e(),_vm._l((_vm.members),function(examiner){return _c('Examiner',{key:examiner.email,attrs:{"examiner":examiner}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }